import React from "react";
import {
  View,
  Text,
  StyleSheet,
  useWindowDimensions,
  Platform,
} from "react-native";
import { RadioButton } from "react-native-paper";
import GlobalStyles from "./StylenColor"; // Adjust the path as necessary

const OptionsList = ({ options, weights, selectedWeight, onSelectOption, isWeb }) => {
  return (
    <View>
      {options.map((option, index) => (
        <View key={index} style={styles.optionContainer}>
          <RadioButton
            value={weights[index]}
            status={selectedWeight === weights[index] ? "checked" : "unchecked"}
            onPress={() => onSelectOption(weights[index])}
          />
          <Text style={[styles.optionText, isWeb && styles.optionTextWeb]}>
            {option}
          </Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  optionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 5,
    paddingRight: 35,
  },
  optionText: {
    marginLeft: 5,
    fontSize: GlobalStyles.fontSize.sm, // Base for mobile
    color: "#333",
    fontFamily: GlobalStyles.inpFont.fontFamily,
    paddingVertical: 1,
  },
  optionTextWeb: {
    fontSize: GlobalStyles.fontSize.xs,
    marginLeft: 5,
    color: "#333",
    fontFamily: GlobalStyles.inpFont.fontFamily,
    paddingVertical: 1,
  },
});

export default OptionsList;
